import * as React from 'react';
import { observer, inject } from "mobx-react";
import history from '../history';
import { Button } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';

// =====================================
// CONSTS
import { Statuses } from '../../const/Statuses';
import { ProductNotes } from '../../const/ProductNotes';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class OrderDetails extends React.Component<{ ordersStore?: IOrdersStore; match?: any }, {}> {

    componentDidMount() {
        const orderId = this.props.match?.params?.orderId;
        const isInboundOrder = this.props.match?.params?.isInboundOrder;
        this.props.ordersStore.getOrderById(orderId, isInboundOrder);
    }

    componentWillUnmount() {
        this.props.ordersStore.reset();
    }

    redirectToEditOrder = () => {
        history.push(`/editorder/${this.props.match?.params?.customerId}/${this.props.match?.params?.orderId}`);
    }

    render() {

        if (this.props.ordersStore.isLoading) {
            return <Loader />;
        }

        return (
            <div className="new-order">
                <Header
                    title="Pregled porudžbine"
                    isBackButtonVisible={true}
                    url={`/orders/${this.props.match?.params?.customerId}`} />

                <div className="container">
                    {this.props.ordersStore.order.products.map((product, i) => {
                        return <div className={`order-container ${product.offeredAmount === 0 ? "highlight-row" : ""}`} key={i}>
                            <div className="product">
                                <div className={`${product.note === ProductNotes.replaced ? "product-name product-name-strike" : "product-name"}`}>{product.name} - {product.unitOfMeasurement}</div>
                                <div className="product-row">
                                    <div>
                                        <div>Šifra: {product.code}</div>
                                        <div>Jedinična cena: {product.realizedSalesPrice.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                    </div>

                                    <div>
                                        <div>Poručeno: {product.orderedAmount}</div>
                                        <div>Ponuđeno: {product.offeredAmount}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}

                    {(this.props.ordersStore.order.status.code === Statuses.PENDING || this.props.ordersStore.order.status.code === Statuses.IN_PREPARATION
                        || this.props.ordersStore.order.status.code === Statuses.PREPARED) ? <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="edit-btn"
                            onClick={this.redirectToEditOrder}
                            startIcon={<EditIcon />}
                        >Izmeni porudžbinu
                    </Button> : null}

                </div>
            </div>
        );
    }
}